import { useCallback } from "react";
import lodash from "lodash";
import { INITIAL_ICF_ERRORS } from "./constants";
import { notify, TYPE } from "@8x8/oxygen-toaster";

const useIcfMutation = ({
  rowsToUpdate,
  areSettingsChanged,
  icfSettings,
  updateIcf,
  pbxId,
  handleUpdateResponse,
  setRowsToUpdate,
  setData,
  idKey,
  setIcfSettingsErrors,
  icfSettingsErrors,
  errorNotification,
}) => {
  return useCallback(() => {
    if (rowsToUpdate.size > 0 || areSettingsChanged) {
      const icfUpdateRequest = {
        subscriptionIdAndDialPlan: Object.fromEntries(
          [...rowsToUpdate].map(([subscriptionId, extension]) => [
            subscriptionId,
            extension.dialPlanRuleSetName,
          ])
        ),
        ...icfSettings,
      };

      updateIcf({ pbxId, icf: icfUpdateRequest })
        .unwrap()
        .then((response) => {
          if (rowsToUpdate.size > 0) {
            handleUpdateResponse({
              rowsToUpdate,
              setRowsToUpdate,
              setData,
              idKey,
            })(response);
          }

          if (areSettingsChanged) {
            // The last 3 objects in the response object are always about icfSettings
            // In case of PBX failure, the message will be caught in catch block

            const icfSettingsResponse = response.slice(-3);
            icfSettingsResponse.forEach(({ operationResult, identifier }) => {
              if (!operationResult?.failed) {
                return;
              }

              if (identifier?.includes("allowInternationalTransfers")) {
                setIcfSettingsErrors({
                  ...icfSettings,
                  allowServiceExtensions: operationResult.failed,
                });
              } else if (identifier?.includes("maxIntlCallFwd")) {
                setIcfSettingsErrors({
                  ...icfSettings,
                  maxCallForwarding: operationResult.failed,
                });
              } else if (identifier?.includes("allowIntlSvcExt")) {
                setIcfSettingsErrors({
                  ...icfSettings,
                  allowTransfers: operationResult.failed,
                });
              }
            });

            if (lodash.isEqual(icfSettingsErrors, INITIAL_ICF_ERRORS)) {
              notify({
                type: TYPE.success,
                content: `ICF Settings changed successfully!`,
                duration: 5000,
              });
              setIcfSettingsErrors(INITIAL_ICF_ERRORS);
            }
          }
        })
        .catch(errorNotification);
    }
  });
};

export default useIcfMutation;
